//import "./node_modules/jquery-modal/jquery.modal.min.css";
import "../node_modules/magnific-popup/dist/magnific-popup.css";
import "./colors.less";
import "./ladzo.less";
import "./fonty.css";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
//import * as jqueryI18next from "jquery-i18next/dist/commonjs/index.js";
//import i18next from "i18next";
//import * as jqueryI18next from "jquery-i18next";

//import { Top } from "./class/Top.js";
import * as pretypuj from "./global/prototype.js";
import { AdminPanel } from "./class/AdminPanel.js";
import * as zahlavi from "./incl/zahlavi.js";
import * as produkty from "./incl/produkty.js";
import * as pata from "./incl/pata.js";
import * as uvod from "./page/uvod.js";
import * as detail from "./page/detail.js";
import * as konfiguraceZbrane from "./page/konfigurace-zbrane.js";
import * as kategorie from "./page/kategorie.js";
import * as kosikStr from "./page/kosik.js";
import * as videoNavody from "./page/video-navody.js";
import ls from "local-storage";
import { Translation as Tr } from "./class/Translation.js";
import { Kosik } from "./class/Kosik.js";
Kosik._init();
import { KonfiguraceZbrane as KF } from "./class/KonfiguraceZbrane.js";

import { WidgetKosik } from "./class/WidgetKosik.js";
import { Top } from "./class/Top";
Top.razitko = window.Ldz.razitko || "1.0.0";

//import StackTrace  from 'stacktrace-js';

//--povoli konzoli

var Url = new URL(window.location.href);

if (process.env.NODE_ENV == "development" || Url.searchParams.has("debug")) {
  Lc.zobraz({ version: "4.0.002", appName: "5M" });
}
Lc.log("process", process.env);
try {
  if (Url.searchParams.has("ldzFetch")) {
    throw new Error("exit script");
  }

  /*
i18next.load({
  cs: {
    "message-goodbye": "Good bye"
  },
  sk: {
    "message-hello": "hola World",
    "message-goodbye": "Good bye"
  }
});
*/
  /*
i18next.init({
  lng: "en", // evtl. use language-detector https://github.com/i18next/i18next-browser-languageDetector
  resources: {
    // evtl. load via xhr https://github.com/i18next/i18next-xhr-backend
    en: {
      translation: {
        input: {
          placeholder: "a placeholder"
        },
        nav: {
          home: "Home",
          page1: "Page One",
          page2: "Page Two"
        }
      }
    }
  }
});
*/
  /*
i18next.init({
  lng: "en", // if you're using a language detector, do not define the lng option
  debug: true,
  resources: {
    en: {
      translation: {
        input: {
          placeholder: "a placeholder"
        },
        nav: {
          home: "Home",
          page1: "Page One",
          page2: "Page Two"
        }
      }
    }
  }
});

jqueryI18next.init(i18next, $, {
  tName: "t", // --> appends $.t = i18next.t
  i18nName: "i18n", // --> appends $.i18n = i18next
  handleName: "localize", // --> appends $(selector).localize(opts);
  selectorAttr: "data-i18n", // selector for translating elements
  targetAttr: "i18n-target", // data-() attribute to grab target element to translate (if diffrent then itself)
  optionsAttr: "i18n-options", // data-() attribute that contains options, will load/set if useOptionsAttr = true
  useOptionsAttr: false, // see optionsAttr
  parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
});

Lc.log("preklad", i18next.t("nav.page2"));
*/

  Lc.log("preklad T", Tr.l("test"));

  //prety
  pretypuj.uprav_datove_typy();

  //$("html").localize();

  //----konfigurator zbrane
  Lc.log("testKonfigurator", ls.get("testKonfigurator"));

  if (Url.searchParams.get("zobrazitKonfiguratorZbrane") == "true") {
    ls.set("zobrazitKonfiguratorZbrane", true);
  } else if (Url.searchParams.get("zobrazitKonfiguratorZbrane") == "false") {
    ls.remove("zobrazitKonfiguratorZbrane");
  }

  if (
    process.env.NODE_ENV == "development" ||
    ls.get("zobrazitKonfiguratorZbrane")
  ) {
    Top.zobrazitKonfiguratorZbrane = true;
  }

  //zakazani konfigurace zbrane pro nečeské stránky
  if (Top.jazyk != "cs") {
    Top.zobrazitKonfiguratorZbrane = false;
  }

  $(document).ready(function() {
    if (
      window.location.pathname.includes("/aktuality/") &&
      window.location.search == "?iframe"
    ) {
      return false;
    }
    $("body").addClass("lang_" + Top.jazyk);
    //---kopntejner pro vlastni hlasky
    $(el("div#dvMessage")).prependTo("body");

    //----konfigurator zbrane

    if (
      Top.zobrazitKonfiguratorZbrane &&
      KF.enable &&
      window.location.href.endsWith("#iframe")
    ) {
      $("body").addClass("bdIframe");
      Top.jeIframe = true;
      //$("#iframeOverlay").hide();
      //var $ss = $(".mfp-content iframe", window.parent.document);
      //$ss.css("height", "600px");
    }

    if (
      Top.zobrazitKonfiguratorZbrane &&
      KF.enable &&
      $("body").hasClass("fancybox-active")
    ) {
      $("body").addClass("bdIframe");
      Top.jeIframe = true;
    }
    //debugger;
    if ($("body").hasClass("type-product")) {
      $("body").addClass("type-detail");
    }
    zahlavi.upravZahlavi();

    AdminPanel.pridejMenu("ulMenu (Ladzo)")
      .then((li) => {
        let objLinks = {
          cs:
            "https://file.corux.cz/save-file/?id=10&token=1e06e3046df1daf09e8632f5686c00c999a9d3d5",
          en:
            "https://file.corux.cz/save-file/?id=12&token=1e06e3046df1daf09e8632f5686c00c999a9d3d5",
          hu:
            "https://file.corux.cz/save-file/?id=13&token=1e06e3046df1daf09e8632f5686c00c999a9d3d5",
          pl:
            "https://file.corux.cz/save-file/?id=14&token=1e06e3046df1daf09e8632f5686c00c999a9d3d5",
        };
        let ul = `<li class="" style="background: #f1f1cb">
                    <span>Stáhni videa z youtube (Ladzo)</span>
                    <ul>`;
        for (var k in objLinks) {
          let url = objLinks[k];
          ul += `<li><a target="_blank" href="${url}">${k}</a>`;
        }
        ul += "</ul></li>";
        li.html(ul);
      })
      .catch((error) => {
        Lc.ctch(error);
      });

    AdminPanel.pridejMenu("Překlady (Ladzo)")
      .then((li) => {
        li.find("a").attr(
          "href",
          process.env.NODE_ENV == "development"
            ? "http://5mf.admin.tld/editor/"
            : "https://admin.5mf.corux.cz/editor/"
        );
        li.find("a").attr("target", "_blank");
        li.attr("style", "background: #f1f1cb");
      })
      .catch((error) => {
        Lc.ctch(error);
      });

    let cil = false;
    if (cil) {
      //Top.zobrazWidget = false;
      //konfiguraceZbrane.upravStrankuKonfiguraceZbrane();
    } else if ($("body").hasClass("type-index")) {
      Top.idStrany = "uvod";
      Top.zobrazWidget = true;
      uvod.upravUvodniStranku();
    } else if ($("body").hasClass("type-detail")) {
      Top.zobrazWidget = true;
      detail.upravDetailProduktuStranku();
    } else if ($("body").hasClass("type-category")) {
      Top.zobrazWidget = true;
      kategorie.upravStranku();
    } else if (window.location.pathname.startsWith("/konfigurace-zbrane/")) {
      Top.zobrazWidget = false;
      konfiguraceZbrane.upravStrankuKonfiguraceZbrane();
    } else if (window.location.pathname.startsWith("/kosik/")) {
      Top.zobrazWidget = true;
      kosikStr.upravStrankuKosiku();
    } else if ($("body").hasClass("id-1967")) {
      //else if (window.location.pathname.startsWith("/video-navody/"))
      videoNavody.upravStranku();
    } else if (window.location.pathname.startsWith("/objednavka/dekujeme/")) {
      kosikStr.resetKosiku();
    }

    Lc.h("kontrola", Top);
    if (Top.zobrazitKonfiguratorZbrane && KF.enable && Top.zobrazWidget) {
      $("body").addClass("bdWidget");
      Lc.h("načtení WidgetKosik");
      let $divWg = WidgetKosik.createDiv("dvWgK");
      if (Top.idStrany == "uvod") {
        $divWg.insertAfter("#header");
      } else {
        $divWg.prependTo("main#content");
      }

      WidgetKosik.zobraz();
    }
    zahlavi.odstranListuPrepocetCen();
    produkty.upravProdukty();

    pata.zobrazPatu();
  });
} catch (error) {
  Lc.err(error);
}
